import OutgoingCheckDetail from '@/models/OutgoingCheck/OutgoingCheckDetail';

export default class OutgoingCheckDetailFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.name = '';
		this.outgoingCheckId  = '';
		this.outgoingCheckOutgoingCheckNumber = '';
		this.deliveryInstructionDetailId  = '';
		this.deliveryInstructionDetailPart = '';
		this.partId  = '';
		this.partPartNumber = '';
		this.deliveryQty = '';
		this.isCompleted = false;
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			name : '0',
			outgoingCheckId : '0',
			outgoingCheckOutgoingCheckNumber : '0',
			deliveryInstructionDetailId : '0',
			deliveryInstructionDetailPart : '0',
			partId : '0',
			partPartNumber : '0',
			deliveryQty : '0',
			isCompleted : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}